// BuscaOS — campo de busca unificado da Agenda/Dashboard.
//
// Filtra visitas por qualquer um destes campos (case-insensitive, sem acento):
//   • voalle_protocolo (número da OS)
//   • cliente_nome
//   • cliente_endereco / cliente_bairro / cliente_cidade
//   • cliente_cpf_cnpj  (matches com/sem pontuação)
//   • tecnico_apelido / tecnico_nome  (substitui a busca-de-técnico separada)
//
// Props:
//   value, onChange    — controlado
//   placeholder        — texto opcional
//   resumo             — opcional: { encontradas, total } pra contador

export default function BuscaOS({
  value,
  onChange,
  placeholder = 'Buscar protocolo, cliente, CPF/CNPJ, endereço, bairro ou técnico…',
  resumo,
}) {
  const ativo = value && value.trim().length > 0;
  return (
    <div className="busca-os">
      <span className="busca-os-icon">🔍</span>
      <input
        type="text"
        className="busca-os-input"
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label="Buscar OS"
      />
      {ativo && (
        <button type="button" className="busca-os-clear"
                onClick={() => onChange('')} aria-label="Limpar busca">✕</button>
      )}
      {ativo && resumo && (
        <span className="busca-os-resumo">{resumo.encontradas} de {resumo.total}</span>
      )}
    </div>
  );
}

// Normaliza string p/ comparação: lowercase + remove acentos.
function _norm(s) {
  if (s == null) return '';
  return String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

// Mantém só dígitos (uso em CPF/CNPJ — busca ignora formatação)
function _digits(s) {
  return s == null ? '' : String(s).replace(/\D+/g, '');
}

// Testa match em qualquer um dos campos pesquisáveis.
export function visitaCasaBusca(visita, termo) {
  if (!termo || !termo.trim()) return true;
  const raw = termo.trim();
  const t   = _norm(raw);
  const td  = _digits(raw);

  // 1) Protocolo (substring numérica)
  if (visita.voalle_protocolo && String(visita.voalle_protocolo).toLowerCase().includes(t)) return true;

  // 2) CPF/CNPJ — só ativa se o termo tem ≥3 dígitos (evita match espúrio em strings curtas)
  if (td.length >= 3 && visita.cliente_cpf_cnpj) {
    const docDigits = _digits(visita.cliente_cpf_cnpj);
    if (docDigits.includes(td)) return true;
  }

  // 3) Campos de texto livre (cliente, endereço, técnico)
  const campos = [
    visita.cliente_nome,
    visita.cliente_endereco,
    visita.cliente_bairro,
    visita.cliente_cidade,
    visita.tecnico_apelido,
    visita.tecnico_nome,
  ];
  for (const c of campos) {
    if (c && _norm(c).includes(t)) return true;
  }

  return false;
}

// Helper: testa se um TÉCNICO casa com o termo (para o filtro de lanes da agenda
// — quando o operador busca "Lucas", queremos mostrar a faixa do Lucas mesmo
// que ele não tenha visita visível no momento).
export function tecnicoCasaBusca(tecnico, termo) {
  if (!termo || !termo.trim()) return true;
  const t = _norm(termo.trim());
  const campos = [tecnico.apelido, tecnico.nome];
  for (const c of campos) {
    if (c && _norm(c).includes(t)) return true;
  }
  return false;
}
